import { Registration } from "./registration";
import { InsuranceData } from "./insuranceData";
export class DmvRegistration {
	registration: Registration;
	selectedRenewalOption: number;
	globalInsuranceData: InsuranceData;
	otherFees?: number;
	oldPlateStyleCost?: number;
	newPlateStyleCost?: number;
	plateStyleCost?: number;
	plateStyleNetChange?: number;
	plateStyleProcessingCost?: number;
	plateStyleRepLacementFee?: number;
	imageCode?: string;
	oldImageCode?: string;
	newImageCode?: string;
	isPlateChange?: boolean;
	altText?: string;
	oldAltText?: string;
	newAltText?: string;
	oldAnnualFee?: number;
	annualFee?: number;
}
